/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import PremiumRibbonIcon from '../icons/PremiumRibbonIcon/PremiumRibbonIcon.js';

const getFeatureCardClasses = small => classNames({
  'quiver-feature-card': true,
  'quiver-feature-card--small': small
});

const getFeatureCardTitleContainerClasses = feedSuperheader => classNames({
  'quiver-feature-card__title__container': true,
  'quiver-feature-card__title__container--hasSuperheader': feedSuperheader
});

const FeatureCard = ({
  imageUrl,
  onClickLink,
  small,
  title,
  displayTitle,
  permalink,
  feedSuperheader,
  isPremium
}) => /*#__PURE__*/React.createElement("a", {
  className: getFeatureCardClasses(small),
  href: permalink,
  onClick: onClickLink
}, isPremium ? /*#__PURE__*/React.createElement(PremiumRibbonIcon, null) : null, /*#__PURE__*/React.createElement("div", {
  className: "quiver-feature-card--inner",
  style: {
    backgroundImage: `url(${imageUrl})`
  }
}), /*#__PURE__*/React.createElement("div", {
  className: getFeatureCardTitleContainerClasses(feedSuperheader)
}, feedSuperheader && !small ? /*#__PURE__*/React.createElement("div", {
  className: "quiver-feature-card__superheader"
}, feedSuperheader) : null, /*#__PURE__*/React.createElement("h2", {
  className: "quiver-feature-card__title"
}, displayTitle || title)));

FeatureCard.defaultProps = {
  imageUrl: null,
  small: false,
  displayTitle: null,
  feedSuperheader: null,
  isPremium: false
};

export default FeatureCard;
//# sourceMappingURL=FeatureCard.js.map
